module.exports = __webpack_public_path__ + "static/Crowns 2 smile after-fa145ba2c176648a36cefb4d4aa9c42b.jpg";